import { render, staticRenderFns } from "./UploadOrganizationFile.vue?vue&type=template&id=03615e9b"
import script from "./UploadOrganizationFile.vue?vue&type=script&lang=js"
export * from "./UploadOrganizationFile.vue?vue&type=script&lang=js"
import style0 from "./UploadOrganizationFile.vue?vue&type=style&index=0&id=03615e9b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports